<template>
    <div
        :id="id"
        class="tl-selection-list-wrapper"
    >
        <div
            class="tl-selection-list"
            :class="{ horizontal }"
            role="group"
        >
            <SelectionListTile
                v-for="(item, index) in items"
                :key="index"
                :loading="loading"
                :item="item"
                :horizontal="horizontal"
                @click="chooseItem(item)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { SelectionListItem } from 'widget-components/integrations/CustomPage/types'
import SelectionListTile from './SelectionListTile.vue'

defineOptions({ inheritAttrs: false })

defineProps<{
    id?: string
    horizontal?: boolean
    items: SelectionListItem[]
    loading?: boolean
}>()

const emit = defineEmits(['itemChosen'])

const chooseItem = (item: SelectionListItem) => {
    emit('itemChosen', item)
}
</script>

<style lang="sass" scoped>
@import './SelectionList.sass'
</style>
